import { render, staticRenderFns } from "./selected-filters-summary.vue?vue&type=template&id=488476a9&scoped=true&"
import script from "./selected-filters-summary.vue?vue&type=script&lang=js&"
export * from "./selected-filters-summary.vue?vue&type=script&lang=js&"
import style0 from "./selected-filters-summary.vue?vue&type=style&index=0&id=488476a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488476a9",
  null
  
)

export default component.exports